/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Merge_Confirm_TypedInputs */

const cs_client_merge_confirm_typed = /** @type {(inputs: Client_Merge_Confirm_TypedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro potvrzení napište jméno cílového klienta`)
};

const en_client_merge_confirm_typed = /** @type {(inputs: Client_Merge_Confirm_TypedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type the target client name to confirm`)
};

/**
* | output |
* | --- |
* | "Type the target client name to confirm" |
*
* @param {Client_Merge_Confirm_TypedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_merge_confirm_typed = /** @type {((inputs?: Client_Merge_Confirm_TypedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Merge_Confirm_TypedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_merge_confirm_typed(inputs)
	return cs_client_merge_confirm_typed(inputs)
});